module.exports = __webpack_public_path__ + "static/apple-store-reversed-b53824a978512e47bbc58037e86c7263.svg";